import React from 'react';
import { Link } from 'Common';
import { t } from 'Utils/localization/i18next';
import Routes from 'Routes/profileRoutes';

export const ResetPasswordLink = () => {
  return (
    <Link
      id="reset-password-link"
      url={`${Routes.RESET_PASSWORD}${window.location.search}`}
      underline
    >
      {t('login.resetPasswordLink')}
    </Link>
  );
};
